/**
 * HOOK: useProductsSelect
 * Hook léger pour charger uniquement les produits nécessaires aux selects
 *
 * ⚡ Optimisation: Ne charge que id + name au lieu de toutes les colonnes
 * 🎯 Usage: Dans les formulaires (ContactInfoForm, CreateCrewModal, etc.)
 *
 * @example
 * const { products, loading } = useProductsSelect();
 *
 * // Au lieu de:
 * // const { products: allProducts } = useProducts(); // ❌ Charge tout
 */

import { useSelectData } from './useSelectData';

interface ProductSelectItem {
  id: string;
  name: string;
}

interface UseProductsSelectReturn {
  products: ProductSelectItem[];
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

/**
 * Hook optimisé pour les selects de produits
 * Ne charge que les colonnes nécessaires (id, name)
 */
export function useProductsSelect(): UseProductsSelectReturn {
  const { data, loading, error, refresh } = useSelectData('products', 'id, name', 'name', true);

  return {
    products: data as ProductSelectItem[],
    loading,
    error,
    refresh,
  };
}
